import { render, staticRenderFns } from "./TabletOrder.vue?vue&type=template&id=45e28bb1&scoped=true"
import script from "./TabletOrder.vue?vue&type=script&lang=js"
export * from "./TabletOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e28bb1",
  null
  
)

export default component.exports